<template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>{{this.$route.name}}</h1>
            <b-row v-if="edicao || visualizacao">
              <b-col cols="2">
                <b-form-group label="Nº do Cadastro: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nº do formulário"
                                  autocomplete="num"
                                  :disabled="true"
                                  v-model.trim="idEditar"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                <b-form-group label="Título do Formulário: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Título do formulário"
                                  :disabled="visualizacao || suspender"
                                  v-model.trim="$v.form.titulo.$model"
                                  :state="chkState('titulo')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Título do Formulário é um campo obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Status:">
                  <b-form-radio-group id="radio-slots" v-model="$v.form.status.$model" :disabled="visualizacao || suspender" :options="options" name="radio-options-slots"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                  <b-form-group>
                    <b-checkbox
                      v-model="form.solicitarResponsavel"
                      :value="true"
                      :disabled="visualizacao || suspender"
                      :unchecked-value="false">Solicitar Responsável pelo preenchimento</b-checkbox>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                  <b-form-group>
                    <b-checkbox
                      v-model="form.solicitarCpf"
                      :value="true"
                      :disabled="visualizacao || suspender"
                      :unchecked-value="false">Solicitar CPF do Responsável pelo preenchimento</b-checkbox>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                  <b-form-group>
                    <b-checkbox
                      v-model="form.solicitarOrganizacao"
                      :value="true"
                      :disabled="visualizacao || suspender"
                      :unchecked-value="false">Solicitar Nome da Organização</b-checkbox>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                  <b-form-group>
                    <b-checkbox
                      v-model="form.solicitarLocalizacao"
                      :value="true"
                      :disabled="visualizacao || suspender"
                      :unchecked-value="false">Obter Localização Geográfica</b-checkbox>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Descrição:" id="fieldset-2" label-for="input-2">
                  <b-input-group class="mb-3">
                      <vue-editor
                      class="editor"
                      :editorToolbar="customToolbar"
                      :disabled="visualizacao || suspender"
                      v-model="form.descricao"
                      ></vue-editor>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-for="(secao, index) in $v.secoes.$each.$iter" :key="index">
              <b-col md="12" sm="8">
                <b-card no-body class="mx-4 secao-content">
                  <b-card-header class="p-12 secao-head">
                    <b-row>
                      <b-col cols="10">
                        <b-form-group label="Seção: *">
                          <b-input-group class="mb-3">
                            <b-form-input type="text"
                                          class="form-control"
                                          placeholder="Título da seção"
                                          :disabled="visualizacao || suspender"
                                          :state="chkStateSecao(index , 'titulo')"
                                          v-model.trim="secao.$model.titulo"/>
                            <b-form-invalid-feedback>Título da Seção é um campo obrigatório.</b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col class="botoes-secao" clos="2">                        
                         <b-btn v-b-toggle="'collapse-' + index">
                             <span class="when-opened">
                                 <i class="fa fa-chevron-down" aria-hidden="true"></i>
                              </span>
                              <span class="when-closed">
                                  <i class="fa fa-chevron-up" aria-hidden="true"></i>
                              </span>                          
                          </b-btn>
                      </b-col>                  
                    </b-row>
                  </b-card-header>
                  <b-card-body class="p-4">
                    <b-collapse visible :id="'collapse-'+index">
                      <b-row v-for="(linha, perguntaIndex) in secao.$model.pergunta" :key="perguntaIndex">
                        <pergunta
                                :ref="'pergunta'"
                                :indexSecao="index"
                                :secao="secao.$model"
                                :status="form.status"
                                :pergunta="linha"
                                :posicao="perguntaIndex"
                                :visualizacao="visualizacao || suspender"
                                :edicao="edicao"
                                :ordenarSecao="secao.$model.ordenar"
                                :salvarForm="salvarForm"
                                :comprimento="secao.$model.pergunta.length"
                                @setaOrdenar="setaOrdenar"
                                >
                        </pergunta>
                      </b-row>
                    </b-collapse>
                  </b-card-body>
                     <b-card-header class="p-12 secao-footer">
                      <b-row>
                        <b-col cols="10">                        
                        </b-col>
                        <b-col class="botoes-secao-footer" v-if="!visualizacao && form.status !== 'SU'" cols="2">
                          <b-button class="btn-secao-actions" variant="primary" title="Adicionar" :disabled="visualizacao || suspender" v-on:click="adicionaSecao">
                            <i class="fa fa-plus"></i>
                          </b-button>
                          <b-button class="btn-secao-actions" variant="danger" title="Remover" v-if="secoes.length > 1" :disabled="visualizacao || suspender" v-on:click="removeSecao(index)">
                            <i class="fa fa-minus"></i>
                          </b-button>
                          <b-button class="btn-secao-actions" variant="secondary" title="Duplicar" :disabled="visualizacao || suspender" v-on:click="duplicaSecao(index)">
                            <i class="fa fa-copy"></i>
                          </b-button>
                          <b-button class="btn-secao-actions" variant="secondary" title="Subir" :disabled="visualizacao || suspender" v-on:click="ordenaUp(index)">
                            <i class="fa fa-arrow-up"></i>
                          </b-button>
                          <b-button class="btn-secao-actions" variant="secondary" title="Descer" :disabled="visualizacao || suspender" v-on:click="ordenaDown(index)">
                            <i class="fa fa-arrow-down"></i>
                          </b-button>
                        </b-col>
                      </b-row>
                  </b-card-header>
                </b-card>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading && !visualizacao && !suspender" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
            </b-col>
            <b-col v-if="loading" md="3">
              <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
                <b-spinner small type="grow"></b-spinner> {{ suspender ? 'Suspendendo...' : 'Salvando...'}}
              </b-button>
            </b-col>
            <b-col v-if="!loading && suspender" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="suspenderQuestionario">
                <i class="fa fa-cancel"></i>&nbsp;
                <span>Suspender</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="voltar()">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import { VueEditor } from 'vue2-editor'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import pergunta from '@/components/questionarios/Pergunta'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Questionario',
  components: {
    VueSelect,
    Multiselect,
    pergunta,
    VueEditor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: { required },
      status: { required }
    },
    secoes: {
      $each: {
        titulo: { required },
        pergunta: {
          $each: {
            titulo: {
              required
            },
            tipo: {
              required
            }
          }
        }
      }
    }
  },
  created () {
    let usuario = SessionStorage.get('usuario')

    this.buscaUsuarioIntegracao(usuario)

    if (!usuario) {
      this.$router.push('/login')
    }
    this.$store.dispatch('atualizarPermissoes')

    if (this.edicao) {
      if (!this.can('questionario.update')) {
        this.$router.push('/')
      }
    } else if (this.visualizacao) {
      if (!this.can('questionario.show')) {
        this.$router.push('/')
      }
    } else if (this.suspender) {
      if (!this.can('questionario.suspend')) {
        this.$router.push('/')
      }
    } else {
      if (!this.can('questionario.store')) {
        this.$router.push('/')
      }
    }

    if (this.$route.params.id) {
      this.setEdit(this.$route.params.id)
    }
  },
  data () {
    return {
      loading: false,
      salvarForm: false,
      idEditar: '',
      usuarioIntegracao: [],
      sistemaIntegracao: [],
      form: {
        titulo: '',
        status: 'AT',
        descricao: '',
        solicitarResponsavel: false,
        solicitarCpf: false,
        solicitarOrganizacao: false,
        solicitarLocalizacao: false

      },
      options: [
        { text: 'Ativo', value: 'AT' },
        { text: 'Inativo', value: 'IN' }
      ],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      secoes: [{
        titulo: '',
        ordem: 1,
        ordemPergunta: 1,
        ordenar: false,
        pergunta: [{
          titulo: '',
          ordem: 1,
          hint: '',
          possuiHint: false,
          tipo: '',
          finaliza: '',
          possuiDependente: '',
          pergunta: [],
          size: '',
          opcoes: [],
          required: false
        }]
      }],
      ordemSecao: 1,
      customToolbar: [
        [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{'script': 'sub'}, { 'script': 'super' }],
        [{'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image', 'video', 'formula'],
        ['clean']]
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError && !this.$v.secoes.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
    invalidPergunta () {
      let invalid = false
      for (let p in this.$refs.pergunta) {
        invalid = this.validatePergunta(this.$refs.pergunta[p])
      }
      return invalid
    },
    visualizacao () {
      return this.$route.matched.some(({ name }) => name === 'Visualizar Estrutura do Formulário')
    },
    suspender () {
      return this.$route.matched.some(({ name }) => name === 'Suspender Formulário')
    },
    edicao () {
      return this.$route.matched.some(({ name }) => name === 'Edição de Formulário')
    },
    duplicacao () {
      return this.$route.matched.some(({ name }) => name === 'Duplicar Formulário')
    },
    usuario () {    
      return this.$store.state.usuario.usuarioEditar
    },
    sistema () {   
      return this.$store.state.sistema.sistemaEditar
    }
  },
  watch: {
    'usuario': function () {   
      this.getSistema()
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    getSistema () {
      if (this.usuario.sistema_cliente_id !== undefined && this.sistema.length < 1) {
        this.$store.dispatch('getSistema', this.usuario.sistema_cliente_id)
      }
    },
    setaOrdenar (indexSecao) {
      this.secoes[indexSecao].ordenar = false
    },
    buscaUsuarioIntegracao(user_id){
      Vue.http.get('api/usuario/' + user_id).then(response => {      
        this.usuarioIntegracao = response.data.data[0]
        if(this.usuarioIntegracao.sistema_cliente_id){
            Vue.http.get('api/sistema/' + this.usuarioIntegracao.sistema_cliente_id).then(response => {
              this.sistemaIntegracao = response.data.data[0]             
            })
        }
      })
    },
    adicionaSecao () {
      this.ordemSecao = this.secoes.length + 1
      this.secoes.push({
        titulo: '',
        ordem: this.ordemSecao,
        ordemPergunta: 1,
        ordenar: false,
        pergunta: [{ titulo: '',
          ordem: 1,
          hint: '',
          possuiHint: false,
          tipo: '',
          size: '',
          finaliza: '',
          possuiDependente: '',
          required: false,
          opcoes: [],
          pergunta: [] }] })

      this.secoes.sort((a, b) => a.ordem - b.ordem)
    },
    removeSecao (index) {
      this.$delete(this.secoes, index)
      this.secoes.sort((a, b) => a.ordem - b.ordem)
    },
    duplicaSecao (index) {
      this.ordemSecao = this.secoes.length + 1
      this.secoes.push({
        titulo: '',
        ordenar: false,
        ordem: this.ordemSecao,
        ordemPergunta: this.secoes[index].ordemPergunta,
        pergunta: []
      })

      this.secoes[index].pergunta.forEach((perguntaDependente) => {
        this.setDuplicaPergunta(perguntaDependente, this.secoes[(this.secoes.length - 1)].pergunta)
      })

      this.secoes.sort((a, b) => a.ordem - b.ordem)
    },
    setDuplicaPergunta (pergunta, array) {
      array.push({
        titulo: pergunta.titulo,
        ordem: pergunta.ordem,
        possuiHint: pergunta.possuiHint,
        hint: pergunta.hint,
        tipo: pergunta.tipo,
        finaliza: pergunta.finaliza,
        possuiDependente: pergunta.possuiDependente,
        size: pergunta.size,
        required: pergunta.required,
        pergunta: [],
        opcoes: []
      })

      pergunta.opcoes.forEach((opcao) => {
        array[(array.length - 1)].opcoes.push({
          resposta: opcao.resposta,
          finaliza: opcao.finaliza,
          possuiDependente: opcao.possuiDependente,
          ordemPergunta: opcao.pergunta.length,
          pergunta: []
        })

        opcao.pergunta.forEach((perguntaDependente) => {
          this.setDuplicaPergunta(perguntaDependente, array[(array.length - 1)].opcoes[(array[(array.length - 1)].opcoes.length - 1)].pergunta)
        })
      })

      pergunta.pergunta.forEach((perguntaDependente) => {
        this.setDuplicaPergunta(perguntaDependente, array[(array.length - 1)].pergunta)
      })
    },
    ordena (array, index, delta) {
      var newIndex = Number(index + delta)
      if (newIndex < 0 || newIndex === array.length) return
      var indexes = [index, newIndex].sort((a, b) => a - b)
      array[index].ordem = newIndex + 1
      array[index].ordenar = true
      array[newIndex].ordem = array[newIndex].ordem - delta
      array[newIndex].ordenar = true
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]])
      this.secoes.sort((a, b) => a.ordem - b.ordem)
    },
    ordenaUp (index) {
      this.ordena(this.secoes, Number(index), -1)
    },
    ordenaDown (index) {
      this.ordena(this.secoes, Number(index), +1)
    },
    setEdit (id) {
      // busca o formulário e seta as informações do mesmo
      Vue.http.get('api/questionario/' + id).then(response => {
        let data = response.body.data[0]

        if (!this.duplicacao) {
          this.idEditar = data.id
          this.form.titulo = data.titulo
          this.form.status = data.status
        }

        this.form.descricao = data.descricao
        this.form.solicitarResponsavel = data.solicitar_responsavel
        this.form.solicitarCpf = data.solicitar_cpf_responsavel
        this.form.solicitarOrganizacao = data.solicitar_nome_org
        this.form.solicitarLocalizacao = data.solicitar_localizacao

        this.secoes = []

        data.secoes.forEach((element) => {
          // cria a secao
          this.secoes.push({
            titulo: element.titulo,
            ordem: element.ordem,
            ordenar: false,
            ordemPergunta: element.pergunta.length,
            pergunta: []
          })

          // percorre as perguntas da seção
          element.pergunta.forEach((element) => {
            // chama o metodo que seta as perguntas e retroativamente suas opções e dependentes
            this.setEditPergunta(element, this.secoes[(this.secoes.length - 1)].pergunta)
          })
        })
      })
    },
    setEditPergunta (pergunta, array) {
      // seta a pergunta pai
      array.push({
        titulo: pergunta.titulo,
        ordem: pergunta.ordem,
        possuiHint: pergunta.hint != null && pergunta.hint !== '',
        hint: pergunta.hint,
        tipo: pergunta.tipo,
        finaliza: pergunta.finaliza_questionario,
        possuiDependente: pergunta.perguntas_dependentes.length > 0,
        size: pergunta.size,
        required: pergunta.required,
        pergunta: [],
        setEdit: true,
        opcoes: []
      })

      // percorre suas opções e as dependentes das opções
      pergunta.opcoes_perguntas_dependentes.forEach((opcaoDependente) => {
        // seta a opção
        array[(array.length - 1)].opcoes.push({
          resposta: opcaoDependente.resposta,
          finaliza: opcaoDependente.finaliza_questionario,
          possuiDependente: opcaoDependente.perguntas_dependentes.length > 0,
          ordemPergunta: opcaoDependente.perguntas_dependentes.length,
          pergunta: []
        })

        // percorre as perguntas dependentes e chama o metodo novamente para essas perguntas assim o metodo repete o processo
        // até que todas as opções estejam alinhadas com suas perguntas incluindo suas dependentes
        opcaoDependente.perguntas_dependentes.forEach((perguntaDependente) => {
          this.setEditPergunta(perguntaDependente, array[(array.length - 1)].opcoes[(array[(array.length - 1)].opcoes.length - 1)].pergunta)
        })
      })

      // percorre as perguntas dependentes e repete o processo com elas, para setar suas opções e perguntas dependentes
      pergunta.perguntas_dependentes.forEach((perguntaDependente) => {
        this.setEditPergunta(perguntaDependente, array[(array.length - 1)].pergunta)
      })
    },
    salvar () {
      let vform = this.$v.form

      let data = {
        'id': this.idEditar,
        'titulo': vform.titulo.$model,
        'status': vform.status.$model,
        'descricao': this.form.descricao,
        'solicitar_responsavel': this.form.solicitarResponsavel,
        'solicitar_cpf_responsavel': this.form.solicitarCpf,
        'solicitar_nome_org': this.form.solicitarOrganizacao,
        'solicitar_localizacao': this.form.solicitarLocalizacao,
        'secoes': this.secoes,
        'id_vinculo_externo': this.$route.params.id_vinculo ? this.$route.params.id_vinculo : null
      }

      this.loading = true
      Vue.http.post('api/questionario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          if (this.sistemaIntegracao.redirect_cadastro) {
            window.location.href = this.sistemaIntegracao.url_cliente
          }

          this.$router.push({path: '/formularios'})
        }

        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
        this.loading = false
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      var validaTipoPergunta = true

      if (this.validate() && validaTipoPergunta && !this.invalidPergunta) {
        this.confirmar()
      }
    },
    suspenderQuestionario () {
      this.loading = true

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/questionario/suspender/' + this.$route.params.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$router.push({path: '/formularios'})
            }
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
            this.loading = false
          })
        }
      }).catch(erro => {
        console.log(erro)
      })

      this.loading = false
    },
    chkState (val) {
      if (!this.visualizacao) {
        const field = this.$v.form[val]

        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    chkStateSecao (index, val) {
      if (!this.visualizacao) {
        const field = this.$v.secoes.$each.$iter[index][val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
        component.$el.focus()
      }

      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()

      this.$nextTick(() => this.findFirstError())

      return this.isValid
    },
    validatePergunta (pergunta) {
      pergunta.validate()

      let invalid = false
      for (let p in pergunta.$refs.pergunta) {
        invalid = this.validatePergunta(pergunta.$refs.pergunta[p])
      }

      if (pergunta.$v.$anyError || invalid) {
        return true
      }
    },
    navigate (route) {
      this.$router.push(route)
    },
    voltar () {
      if (this.sistemaIntegracao.redirect_cadastro) {
        window.location.href = this.sistemaIntegracao.url_cliente
      } else {
        return this.$router.push('/formularios')
      }
    }
  }
}
</script>

<style scoped>
.botoes-secao{
  padding-top: 27px;
  text-align: left;
}
.btn-secao-actions {
  width: 27px;
  height: 28px;
  padding: 3px 3px 3px 3px;
}

.secao-head {
  background-color: lightgrey;
}

.secao-footer {
  background-color: lightgrey;
}

.botoes-secao-footer{
  padding-top: 8px;
  text-align: right;
  margin-bottom: 7px;
}

.secao-content {
  border-color: lightslategray !important;
}

.collapsed > .when-closed,
:not(.collapsed) > .when-opened {
  display: none;
}
</style>

<style>
.editor{
  width: 100%;
  height: 80%;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/questionarios/CadastrarQuestionarios.vue